<template>
  <div class="my-text">
    <span :style="{ ...props.textStyle }">{{ format() }}</span>
    <span v-if="props.unit">{{ props.unit }}</span>
  </div>
</template>

<script setup>
  import { defineProps } from 'vue';
  import { dateFormat } from '@/utils';
  const props = defineProps({
    modelValue: {
      type: [String, Number, Array], 
    },
    mode: {
      type: [String], 
    },
    format: {
      type: [Function],
    },
    default:{
      type: [String],
      default:"- -"
    },
    unit:{
      type: [String],
      default:""
    },
    textStyle:{
      type: [Object],
      default: () => ({}),
    },
  });

  const format = () => {
    if (props.format) {
      return props.format(props.modelValue);
    }
    if (!props.mode) {
      return (props.modelValue === null || props.modelValue === undefined || props.modelValue === "")? props.default : props.modelValue;
    }
    if (props.mode == 'time') {
      return dateFormat(props.modelValue, 'YYYY/MM/DD HH:mm:ss');
    }
    if (props.mode == 'date') {
      return dateFormat(props.modelValue, 'YYYY/MM/DD');
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-text {
    display: inline-block;
    width: 100%;
    margin: 4px 0;
    word-wrap: break-word;
  }
</style>
